import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface EventPickerData {
    mode: 'init';
    eventName: string;
    eventValue?: string;
    eventNames?: string[];
}

@Component({
    selector: 'app-event-picker-dialog',
    standalone: false,
    template: `
        <div class="section-header" mat-dialog-title>
            <mat-icon class="section-icon">bolt</mat-icon>
            <span class="section-title">init event</span>
            <button mat-icon-button class="close-button" mat-dialog-close>
                <mat-icon>close</mat-icon>
            </button>
        </div>
        <div mat-dialog-content style="padding: 8px 16px 0 16px; overflow: hidden; max-height: none">
            <div style="margin-bottom: 8px; display: flex; align-items: center; gap: 8px">
                <span style="font-size: 12px; opacity: 0.7">event:</span>
                <input [(ngModel)]="eventName" placeholder="event name"
                       style="flex: 1; font-family: monospace; font-size: 14px; padding: 4px 8px; border-radius: 4px;
                              border: 1px solid rgba(255,255,255,0.2); background: var(--background-color2); color: #2196F3; font-weight: bold">
            </div>
            <div *ngIf="data.mode === 'init'" style="margin-bottom: 8px; display: flex; align-items: center; gap: 8px">
                <span style="font-size: 12px; opacity: 0.7">value:</span>
                <input [(ngModel)]="eventValue" placeholder="value"
                       style="flex: 1; font-family: monospace; font-size: 14px; padding: 4px 8px; border-radius: 4px;
                              border: 1px solid rgba(255,255,255,0.2); background: var(--background-color2); color: inherit">
            </div>
            <div *ngIf="data.eventNames?.length" style="margin-top: 8px">
                <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 4px">
                    <span style="font-size: 11px; opacity: 0.5">available events:</span>
                    <input [(ngModel)]="eventFilter" placeholder="filter..."
                           style="flex: 1; font-size: 11px; padding: 2px 6px; border: 1px solid rgba(255,255,255,0.15);
                                  border-radius: 3px; background: transparent; color: inherit">
                </div>
                <div style="display: flex; flex-wrap: wrap; gap: 4px; max-height: 180px; overflow-y: auto; overflow-x: hidden; padding: 2px 0">
                    <span *ngFor="let name of filteredEvents"
                        (click)="eventName = name"
                        [style.background]="eventName === name ? 'rgba(76, 175, 80, 0.15)' : 'transparent'"
                        [style.border-width]="eventName === name ? '2px' : '1px'"
                        style="padding: 2px 8px; font-size: 11px; color: #4caf50; border: 1px solid #4caf50;
                               border-radius: 3px; cursor: pointer; white-space: nowrap; line-height: 18px">
                        {{ name }}
                    </span>
                </div>
            </div>
        </div>
        <div mat-dialog-actions align="end" style="padding: 8px 16px">
            <button mat-button [mat-dialog-close]="null">Cancel</button>
            <button mat-raised-button color="primary" (click)="save()" [disabled]="!eventName.trim()">OK</button>
        </div>
    `,
    styles: [`
        :host ::ng-deep {
            .section-header {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 12px 16px;
                background: var(--background-color2);
                border-left: 4px solid #2196F3;
                margin: 0 0 0 0;

                .section-icon {
                    color: #2196F3;
                    margin-right: 8px;
                    font-size: 18px !important;
                    width: 18px !important;
                    height: 18px !important;
                }

                .section-title {
                    color: var(--text-primary);
                    font-size: 13px;
                    font-weight: 500;
                    text-transform: lowercase;
                    letter-spacing: 0.5px;
                    flex: 1;
                }

                .close-button {
                    opacity: 0.7;
                    transition: all 0.3s ease;
                    &:hover {
                        opacity: 1;
                        transform: rotate(90deg);
                    }
                }
            }
        }
    `]
})
export class EventPickerDialogComponent {
    eventName: string;
    eventValue: string;
    eventFilter = '';

    constructor(
        private dialogRef: MatDialogRef<EventPickerDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: EventPickerData
    ) {
        this.eventName = data.eventName || '';
        this.eventValue = data.eventValue || '';
        if (data.eventNames) {
            data.eventNames = [...data.eventNames].sort((a, b) => a.localeCompare(b));
        }
    }

    get filteredEvents(): string[] {
        if (!this.data.eventNames) return [];
        if (!this.eventFilter) return this.data.eventNames;
        const f = this.eventFilter.toLowerCase();
        return this.data.eventNames.filter(n => n.toLowerCase().includes(f));
    }

    save(): void {
        if (!this.eventName.trim()) return;
        this.dialogRef.close({ eventName: this.eventName.trim(), eventValue: this.eventValue });
    }
}
